<template>
    <div class="w-full sticky shrink-0 overflow-y-auto overflow-x-hidden px-0 pt-0 flex-1" style="top:0px">
        <fs-multiple-info v-if="selected.length > 1" @go="navigateTo" :selected="selected"
                          @closeContextMenus="$emit('closeContextMenus')"
        ></fs-multiple-info>
        <template v-if="lastMousedOver">
            <fs-directory-info v-if="lastMousedOver.isDirectoryType" :directory="lastMousedOver"
                               @closeContextMenus="$emit('closeContextMenus')"
                               :filesystem="filesystem" @navigateTo="navigateTo" :prefs ="prefs"
            ></fs-directory-info>
            <fs-file-info v-if="!lastMousedOver.isDirectoryType" :file="lastMousedOver"
                          @closeContextMenus="$emit('closeContextMenus')"
                          ref="file" :rotations="rotations" :prefs ="prefs"
                          :filesystem="filesystem" @navigateTo="navigateTo" @preview="(node) => $emit('preview',this.selected[0],node)"
            ></fs-file-info>
        </template>
        <template v-else>
            <fs-directory-info v-if="(selected.length === 1) && selected[0].isDirectoryType" :directory="selected[0]"
                               :filesystem="filesystem" @navigateTo="navigateTo" :prefs ="prefs"
                               @closeContextMenus="$emit('closeContextMenus')"
            ></fs-directory-info>
            <fs-file-info v-if="(selected.length === 1) && !selected[0].isDirectoryType" :file="selected[0]"
                          :filesystem="filesystem" @navigateTo="navigateTo" @preview="(node) => $emit('preview',this.selected[0],node)"
                          ref="file" :rotations="rotations" :prefs ="prefs"
                          @closeContextMenus="$emit('closeContextMenus')"
            ></fs-file-info>
            <div v-if="selected.length == 0" class="flex items-center justify-center h-full mx-3" style="min-width:250px">
                <div class="text-center flex-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22px" height="22px" viewBox="0 0 24 24" fill="none"
                         stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                         class="vue-feather mb-3 inline-block text-gray-500 feather feather-eye-off">
                        <path
                            d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                        <line x1="1" y1="1" x2="23" y2="23"></line>
                    </svg>
                    <small class="block text-xs text-gray-500">
                        There is nothing to preview.
                    </small>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import FsMultipleInfo from "./FsMultipleInfo.vue";
import FsDirectoryInfo from "./FsDirectoryInfo.vue";
import FsFileInfo from "./FsFileInfo.vue";

export default {
    components: {FsFileInfo, FsDirectoryInfo, FsMultipleInfo},
    props: {
        filesystem: Object,
        rotations: Object,
        selected: Array,
        lastMousedOver: false,
        prefs : Object,
    },
    data() {
        return {}
    },
    computed: {},
    methods: {
        navigateTo(destination) {
            this.$emit('navigateTo', destination)
        },
        resize() {
            if ( this.$el.parentElement) {
                let offset = this.$el.parentElement.parentElement.parentElement.firstElementChild.getBoundingClientRect().height;
                this.$el.setAttribute('style', 'top:' + offset + 'px;')
            } else {
                window.removeEventListener('resize', this.resize)
            }
        },
    },
    updated() {
        this.resize()
    },
    mounted() {
        this.resize()
        window.addEventListener('resize', this.resize, true);
        this.$on('hook:beforeDestroy', () => {
            window.removeEventListener('resize', this.resize)
        })
    }
}
</script>

